// extracted by mini-css-extract-plugin
export default {"sideMenuItem":"SideMenuItem_sideMenuItem__rHVgN","icon":"SideMenuItem_icon__FRn2t","menuLink":"SideMenuItem_menuLink__ySIZG","text":"SideMenuItem_text__AsUmm"};